import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '@/components/Navbar';
import HomeHero from '@/components/HomeHero';
import Marquee from '@/components/Marquee';
import Services from '@/components/Services';
import About from '@/components/About';
import Portfolio from '@/components/Portfolio';
import Testimonials from '@/components/Testimonials';
import QuoteWizard from '@/components/QuoteWizard';
import Footer from '@/components/Footer';
import StickyCallBar from '@/components/StickyCallBar';
import SEOHead from '@/components/SEOHead';
import { useLang } from '@/context/LanguageContext';

export default function HomePage() {
  const { lang } = useLang();
  const [wizardOpen, setWizardOpen] = useState(false);

  const title = lang === 'es'
    ? 'Contractors of South Florida | Mejoras del Hogar'
    : 'Contractors of South Florida | Home Improvement Experts';
  const desc = lang === 'es'
    ? 'Contratistas licenciados en el sur de Florida. Techos, ventanas de impacto, aire acondicionado, remodelación y construcción nueva.'
    : 'Licensed contractors in South Florida. Roofing, impact windows, HVAC, remodeling, and new construction. Free quotes.';

  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <SEOHead title={title} description={desc} url={lang === 'es' ? '/es' : '/'} lang={lang} />
      <Navbar />
      <main>
        <HomeHero onOpenWizard={() => setWizardOpen(true)} />
        <Marquee />
        <Services />
        <About />
        <Portfolio />
        <Testimonials />

        {/* CTA Section with embedded wizard */}
        <section id="contact" className="py-24 sm:py-32 border-t border-white/5">
          <div className="max-w-xl mx-auto px-6">
            <div className="text-center mb-8">
              <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#E31937] mb-4">
                {lang === 'es' ? 'Obtenga Su Cotización' : 'Get Your Quote'}
              </p>
              <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-white">
                {lang === 'es' ? 'Comience su proyecto hoy.' : 'Start your project today.'}
              </h2>
            </div>
            <div className="bg-[#141414] border border-white/10 p-6 sm:p-8">
              <QuoteWizard embedded />
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <StickyCallBar />

      {/* Floating Wizard Modal */}
      <AnimatePresence>
        {wizardOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setWizardOpen(false)}>
            <motion.div initial={{ scale: 0.95, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 20 }}
              className="bg-[#141414] border border-white/10 w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 sm:p-8" onClick={e => e.stopPropagation()}>
              <div className="flex justify-end mb-2">
                <button onClick={() => setWizardOpen(false)} className="text-[#666] hover:text-white text-sm">Close</button>
              </div>
              <QuoteWizard onClose={() => setWizardOpen(false)} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
